
interface BookingButtonProps {
  className?: string;
  children?: React.ReactNode;
}

const BookingButton = ({ 
  className, 
  children = "Prendre rendez-vous"
}: BookingButtonProps) => {
  return (
    <a 
      href="https://www.kalendes.com/site/biobeautezen/welcome#%2Freserve"
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      {children}
    </a>
  );
};

export default BookingButton;
